$(function () {
    if (!$('#gcv-comisiones-empleado').length) {
        return;
    }
    var H = GcvComisionesHelper;
    H.init({
        tableSelector: '#gcvComisionesEmpleadoTable',
        filterSelector: '#gcvComisionesEmpleadoFilter',
        searchButton: '#gcvComisionesEmpleadoBuscar',
        exportButton: '#gcvComisionesEmpleadoExportar',
        exportUrl: HOST + '/comisiones/empleado/export',
        dataUrl: HOST + '/comisiones/empleado/data',
        queryType: 'empleado',
        useUrlPagination: true,
        order: [[0, 'DESC']],
        totalesFields: ['comision_empleado', 'comision_empleado_prevista', 'comision_empleado_max_prevista'],
        columns: [
            {data: 'periodo', title: 'PERIODO', className: 'uk-text-center'},
            {data: 'comisionista', title: 'COMISIONISTA', className: 'uk-text-center'},
            {data: 'empleado', title: 'EMPLEADO', className: 'uk-text-center', width: '220px'},
            {data: 'comision', title: 'DENOMINACIÓN COMISIÓN', className: 'uk-text-center', width: '280px'},
            H.pctUmbralViabilidadCol('mult_umb_via', '% UMB. VIAB.'),
            H.decimalCol('pct_stock_obsoleto', '% STOCK OBS.'),
            H.decimalCol('pto_exc_total', 'PTO. EXC.'),
            H.decimalCol('mult_umb_via', 'MULT. VIAB.'),
            H.decimalCol('mult_umb_via_max', 'MULT. VIAB. MÁX.'),
            H.decimalCol('mult_pto_exc', 'MULT. EXC.'),
            H.decimalCol('mult_pto_exc_max', 'MULT. EXC. MÁX.'),
            H.decimalCol('comision_empleado', 'COM. EMPLEADO', true),
            H.decimalCol('pct_umbral_viabilidad_previsto', '% UMB. VIAB. PREV.'),
            H.decimalCol('mult_umb_via_previsto', 'MULT. VIAB. PREV.'),
            H.decimalCol('comision_empleado_prevista', 'COM. EMPLEADO PREV.', true),
            H.decimalCol('comision_empleado_max_prevista', 'COM. EMPLEADO PREV. MÁX.', true)
        ]
    });
});
